
import Const from '../utils/const';

export const SocialMixin = {
    data() {
        return {
            Const,
        }
    },
    computed: {
    },
    methods: {
        kakaoOAuth() {
            if(window.Android) {
                window.Android.kakaoSocialLogin();
            } else {
                this.callbackPopup('KakaoSignIn');
            }
        },
        
        kakaoLogin(auth) {
            if(auth) {
                this.$store.dispatch("LOGIN_WITH_KAKAO", auth)
                .then(() => {
                    this.openPopupMsg('Kakao 연결이 완료되었습니다.');
                    this.loginSuccess();
                }).catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

		kakaoConnect(auth) {
            if(auth) { 
                this.$store.dispatch("CONNECT_WITH_KAKAO", auth)
                .then(()=>{
                    this.openPopupMsg('Kakao 연결이 완료되었습니다.');
                    this.connectSuccess();
                })
                .catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

        googleOAuth() {
            if(window.Android) {
                window.Android.googleSocialLogin();
            } else {
                this.callbackPopup('GoogleSignIn');
            }
        },

        googleLogin(auth) {
            if(auth){
                this.$store.dispatch("LOGIN_WITH_GOOGLE", auth)
                .then(() => {
                    this.openPopupMsg('Google 로그인이 완료되었습니다.');
                    this.loginSuccess();
                }).catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

		googleConnect(auth) {
            if(auth) {
                this.$store.dispatch("CONNECT_WITH_GOOGLE", auth)
                .then(() => {
                    this.openPopupMsg('Google 연결이 완료되었습니다.');
                    this.connectSuccess();
                })
                .catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

        appleOAuth(){
            // this.openPopupMsg('준비중인 서비스 입니다.');
            this.callbackPopup('AppleSignIn');
        },

        appleLogin(auth) {
            if(auth){
                this.$store.dispatch("LOGIN_WITH_APPLE", auth)
                .then(() => {
                    this.openPopupMsg('Apple 로그인이 완료되었습니다.');
                    this.loginSuccess();
                }).catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

		appleConnect(auth) {
            if(auth) {
                this.$store.dispatch("CONNECT_WITH_APPLE", auth)
                .then(() => {
                    this.openPopupMsg('Apple 연결이 완료되었습니다.');
                    this.connectSuccess();
                })
                .catch((e) => {
                    this.apiCatch(e);
                });
            }
		},

        loginSuccess(){
            this.$router.push('/main');
        },

        connectSuccess(){
            let routeName = this.$route.name;
            let path = '';
            switch (routeName) {
                case 'JoinSocial': path = '/main'; break;
                // case 'JoinSocial': path = '/join/complete'; break;
                case 'MyInfo': path = ''; break;
            }

            if(path) this.$router.push(path);
        }

    },
};